/**
 * Resting + hover chrome for launchpad feed list row/cards and any surface that
 * should match that shell (e.g. social leaderboard `DataTable` feed variant).
 *
 * Cards rest FLAT (hairline border only, both modes) and lift to the `card`
 * elevation role on hover/focus.
 * {@link FEED_CARD_HOVER_BACKGROUND} adds an extra dark-mode hover wash on top.
 */
export const FEED_CARD_RESTING_OUTLINE =
  'relative overflow-hidden border-solid border border-border-primary dark:border-border-primary' as const;

/**
 * Dark-mode-only hover tint, layered on top of the {@link FEED_CARD_OUTLINE_INTERACTION}
 * elevation lift.
 */
export const FEED_CARD_HOVER_BACKGROUND = 'dark:hover:bg-background-tertiary/50' as const;

export const FEED_CARD_OUTLINE_INTERACTION =
  'transition-[box-shadow,border-color,background-color] duration-fast ease-default motion-reduce:transition-none hover:border-border-primary hover:shadow-elevation-card focus-visible:border-border-primary focus-visible:shadow-elevation-card focus-visible:outline-none' as const;
